import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Grid, List, ListItem, Typography } from "@mui/material";
import "../../Styles/Layouts/common_sidebar.css";
import { useLocation } from "react-router-dom";
import logo from "../../Assets/logo.svg";

const Superadmin_sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //destructuring pathname from location
  const { pathname } = location;

  const handleLogout = () => {
    // Remove the token from local storage
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/superadmin");
    window.location.reload();
  };

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  return (
    <React.Fragment>
      <Grid sx={{ width: "100%" }} container spacing={2}>
        <Grid sx={{ width: "17%" }} item>
          <div className="sidebar-content">
            <div className="main-logo">
              <img src={logo} alt="logo" />
            </div>
            <List>
              <Link to="/superadmin/Dashboard">
                <ListItem
                  className={
                    splitLocation[1] === "superadmin" &&
                    splitLocation[2] === "Dashboard"
                      ? "active"
                      : ""
                  }
                >
                  Dashboard
                </ListItem>
              </Link>
              <Link to="/superadmin/Vendors">
                <ListItem
                  className={
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "Vendors") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "ActiveFieldOfficers") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "InactiveFieldOfficers") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "Fields") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "FieldDetails") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "AllDetails") ||
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "StatusFieldOfficers")
                      ? "active"
                      : ""
                  }
                >
                  Vendors
                </ListItem>
              </Link>
            </List>
            <div className="logout-btn">
              <button className="logout" color="error" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </Grid>
        <Grid sx={{ width: "83%" }} item>
          <Outlet />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Superadmin_sidebar;
